<template>
  <page-header-wrapper>
    <!-- <JeepayCard title="申请提现"> -->
    <!-- 可结算金额展示 -->
    <div class="available-amount-card">
      <span class="amount-label">可结算金额:</span>
      <span class="amount-value">{{ formatAmount(availableAmount, '₹') }}</span>
      <a-button
        type="link"
        size="small"
        @click="refreshAvailableAmount"
        :loading="loadingAmount"
      >
        刷新
      </a-button>
    </div>

    <a-form-model
      ref="form"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 账户类型 -->
      <a-form-model-item label="账户类型" prop="accountType">
        <a-radio-group v-model="formData.accountType" @change="onAccountTypeChange">
          <!-- 从结算账户列表拉取 -->
          <a-radio value="select">结算账户</a-radio>
          <a-radio value="manual" disabled>手动录入</a-radio>

        </a-radio-group>
      </a-form-model-item>

      <!-- 手动录入模式 -->
      <template v-if="formData.accountType === 'manual'">
        <!-- 账户类型选择 -->
        <a-form-model-item label="账户类型" prop="accountType">
          <a-radio-group v-model="formData.accountTypeEnum" @change="onAccountTypeEnumChange">
            <a-radio :value="1">银行账户</a-radio>
            <a-radio :value="2">USDT(TRC20)</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 银行账户字段 -->
        <template v-if="formData.accountTypeEnum === 1">
          <a-form-model-item label="账户别名" prop="accountName">
            <a-input v-model="formData.accountName" placeholder="请输入账户别名" />
          </a-form-model-item>
          <a-form-model-item label="IFSC Code" prop="ifscCode">
            <a-input
              v-model="formData.ifscCode"
              placeholder="请输入4位银行代码(如:HDFC)或11位完整IFSC代码"
              @blur="onIfscCodeBlur"
              @input="onIfscCodeInput"
            />
            <div v-if="ifscQueryStatus === 'success'" class="ifsc-bank-info success">
              <a-icon type="check-circle" /> 识别银行: {{ bankNameFromIFSC }}
            </div>
            <div v-else-if="ifscQueryStatus === 'failed'" class="ifsc-bank-info error">
              <a-icon type="exclamation-circle" /> 银行代码无效，请手动输入银行名称
            </div>
            <div v-else-if="ifscQueryStatus === 'loading'" class="ifsc-bank-info loading">
              <a-icon type="loading" /> 正在查询银行信息...
            </div>
          </a-form-model-item>

          <a-form-model-item label="银行名称" prop="bankName">
            <a-input
              v-model="formData.bankName"
              placeholder="请输入银行名称"
              :disabled="ifscQueryStatus === 'success'"
            />
            <div v-if="ifscQueryStatus === 'success'" class="bank-name-tip">
              银行名称已根据IFSC代码自动填充
            </div>
          </a-form-model-item>

          <a-form-model-item label="收款人姓名" prop="payeeName">
            <a-input v-model="formData.payeeName" placeholder="请输入收款人姓名" />
          </a-form-model-item>

          <a-form-model-item label="账户号码" prop="accountNo">
            <a-input v-model="formData.accountNo" placeholder="请输入账户号码" />
          </a-form-model-item>
        </template>

        <!-- USDT账户字段 -->
        <template v-if="formData.accountTypeEnum === 2">
          <a-form-model-item label="账户名称" prop="accountName">
            <a-input v-model="formData.accountName" placeholder="请输入账户名称" />
          </a-form-model-item>
          <a-form-model-item label="USDT地址" prop="accountNo">
            <a-input v-model="formData.accountNo" placeholder="请输入USDT地址" />
          </a-form-model-item>

          <a-form-model-item label="银行名称" prop="bankName">
            <a-input v-model="formData.bankName" placeholder="请输入银行名称" :disabled="formData.accountTypeEnum === 2" />
          </a-form-model-item>
        </template>

        <!-- 是否默认 -->
        <a-form-model-item label="是否默认" prop="isDefault">
          <a-switch
            :checked="formData.isDefault === 1"
            @change="(checked) => formData.isDefault = checked ? 1 : 0"
          >
            <span slot="checkedChildren">是</span>
            <span slot="unCheckedChildren">否</span>
          </a-switch>
        </a-form-model-item>

        <a-form-model-item label="结算金额" prop="amount">
          <a-input
            v-model="formData.amount"
            placeholder="请输入结算金额"
            suffix="₹"
          />
        </a-form-model-item>
      </template>

      <!-- 选择账户模式 -->
      <template v-if="formData.accountType === 'select'">
        <a-form-model-item label="账户信息" prop="selectedAccount">
          <a-select
            v-model="formData.selectedAccount"
            placeholder="请选择"
            @change="onAccountSelect"
          >
            <!-- accountList 是结算账户列表, isActive 是是否可用 -->
            <a-select-option
              v-for="account in accountList"
              :key="account.id"
              :value="account.id"
              :disabled="account.isActive === false"
            >
              {{ account.accountName }} - {{ account.bankName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="结算金额" prop="amount">
          <a-input
            v-model="formData.amount"
            placeholder="请输入结算金额"
            suffix="₹"
          />
        </a-form-model-item>
      </template>

      <!-- 银行账户模式 -->
      <template v-if="formData.accountType === 'merchant'">
        <a-form-model-item label="账户信息" prop="merchantAccount">
          <a-select
            v-model="formData.merchantAccount"
            placeholder="请选择"
            @change="onMerchantAccountSelect"
          >
            <a-select-option
              v-for="account in merchantAccountList"
              :key="account.id"
              :value="account.id"
            >
              {{ account.accountName }} - {{ account.bankName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="结算金额" prop="amount">
          <a-input
            v-model="formData.amount"
            placeholder="请输入结算金额"
            suffix="₹"
          />
        </a-form-model-item>
      </template>

      <!-- 提交按钮 -->
      <a-form-model-item :wrapper-col="{ span: 18, offset: 6 }">
        <a-button type="primary" @click="submitApplication" :loading="submitting">
          提交申请
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- </JeepayCard> -->
  </page-header-wrapper>
</template>

<script>
import JeepayCard from '@/components/JeepayCard/JeepayCard'
import { getAvailableSettlementAmount, API_URL_SETTLEMENT_ACCOUNT_LIST, applySettlement } from '@/api/settlement'
import { req } from '@/api/manage'
import { getBankNameByIFSC, validateIFSCFormat, formatIFSCCode } from '@/utils/ifscUtil'
import { formatAmount, formatNumber } from '@/utils/util'

export default {
  name: 'SettlementApply',
  components: {
    JeepayCard
  },
  data () {
    return {
      submitting: false,
      loadingAmount: false,
      availableAmount: '0.00',
      formData: {
        accountType: 'select', // 默认手动录入
        accountTypeEnum: 1,
        ifscCode: '',
        bankName: '',
        payeeName: '',
        accountName: '',
        accountNo: '',
        amount: '',
        selectedAccount: undefined,
        merchantAccount: undefined,
        isDefault: 0
      },
      rules: {
        accountType: [
          { required: true, message: '请选择账户类型', trigger: 'change' }
        ],
        accountTypeEnum: [
          { required: true, message: '请选择账户类型', trigger: 'change' }
        ],
        ifscCode: [
          { required: true, message: '请输入IFSC Code', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入银行名称', trigger: 'blur' }
        ],
        payeeName: [
          { required: true, message: '请输入收款人姓名', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入账户名称', trigger: 'blur' }
        ],
        accountNo: [
          { required: true, message: '请输入账户号码', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入结算金额', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        selectedAccount: [
          { required: true, message: '请选择账户', trigger: 'change' }
        ],
        merchantAccount: [
          { required: true, message: '请选择账户', trigger: 'change' }
        ],
        isDefault: [
          { required: false, message: '请选择是否默认', trigger: 'change' }
        ]
      },
      accountList: [], // 开户账户列表
      merchantAccountList: [], // 银行账户列表
      ifscQueryStatus: '',
      bankNameFromIFSC: ''
    }
  },
  mounted () {
    this.loadAccountList()
    this.loadMerchantAccountList()
    this.getAvailableAmount()
  },
  methods: {
    // 获取可结算金额
    async getAvailableAmount () {
      this.loadingAmount = true
      try {
        const response = await getAvailableSettlementAmount()
        this.availableAmount = response || '0.00'
      } catch (error) {
        console.error('获取可结算金额失败:', error)
        this.$message.error('获取可结算金额失败')
      } finally {
        this.loadingAmount = false
      }
    },

    // 刷新可结算金额
    refreshAvailableAmount () {
      this.getAvailableAmount()
    },

    // 账户类型变化
    onAccountTypeChange (e) {
      // 清空表单数据
      this.resetFormData()
    },

    // 重置表单数据
    resetFormData () {
      this.formData = {
        ...this.formData,
        ifscCode: '',
        bankName: '',
        payeeName: '',
        accountName: '',
        accountNo: '',
        amount: '',
        selectedAccount: undefined,
        merchantAccount: undefined,
        isDefault: 0
      }
    },

    // 选择账户
    onAccountSelect (accountId) {
      const account = this.accountList.find(item => item.id === accountId)
      if (account) {
        // 可以在这里自动填充一些信息
        console.log('选择的账户:', account)
      }
    },

    // 选择银行账户
    onMerchantAccountSelect (accountId) {
      const account = this.merchantAccountList.find(item => item.id === accountId)
      if (account) {
        // 可以在这里自动填充一些信息
        console.log('选择的银行账户:', account)
      }
    },

    // 加载开户账户列表
    async loadAccountList () {
      try {
        // 这里调用实际的API
        // const response = await req.list('/api/settlement/accounts', {})
        // this.accountList = response.records || []
        // 调用接口API_URL_SETTLEMENT_ACCOUNT_LIST
        // 获取结算账户列表
        const response = await req.getList(API_URL_SETTLEMENT_ACCOUNT_LIST, {})
        this.accountList = response.records || []
      } catch (error) {
        console.error('加载账户列表失败:', error)
        this.$message.error('加载账户列表失败')
      }
    },

    // 加载银行账户列表
    async loadMerchantAccountList () {
      try {
        // 这里调用实际的API
        // const response = await req.list('/api/settlement/merchant-accounts', {})
        // this.merchantAccountList = response.records || []

        // 模拟数据
        this.merchantAccountList = [
          {
            id: 1,
            accountName: '商户账户A',
            bankName: 'Bank of India',
            accountNo: '4567890123456789'
          },
          {
            id: 2,
            accountName: '商户账户B',
            bankName: 'Punjab National Bank',
            accountNo: '5678901234567890'
          }
        ]
      } catch (error) {
        console.error('加载银行账户列表失败:', error)
        this.$message.error('加载银行账户列表失败')
      }
    },

    // 提交申请
    submitApplication () {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return
        }

        this.submitting = true
        try {
          // 构建提交数据
          const submitData = {
            // accountType: this.formData.accountType,
            settlementAmount: this.formData.amount,
            fee: 0
          }

          if (this.formData.accountType === 'manual') {
            Object.assign(submitData, {
              accountType: this.formData.accountTypeEnum,
              ifscCode: this.formData.ifscCode,
              bankName: this.formData.bankName,
              payeeName: this.formData.payeeName,
              accountName: this.formData.accountName,
              accountNo: this.formData.accountNo,
              isDefault: this.formData.isDefault
            })
          } else if (this.formData.accountType === 'select') {
            Object.assign(submitData, {
              settlementAccountId: this.formData.selectedAccount
            })
          }

          // 这里调用实际的提交API
          // await req.create('/api/settlement/apply', submitData)
          await applySettlement(submitData)

          console.log('提交数据:', submitData)

          this.$message.success('申请提交成功')
          // 刷新结算金额
          this.getAvailableAmount()
          this.resetFormData()

          // 可以跳转到申请列表页面
          // this.$router.push('/settlement')
        } catch (error) {
          console.error('提交申请失败:', error)
          this.$message.error('提交申请失败')
        } finally {
          this.submitting = false
        }
      })
    },

    // 账户类型变化
    onAccountTypeEnumChange () {
      // 清空相关字段
      this.formData.ifscCode = ''
      this.formData.bankName = ''
      this.formData.payeeName = ''
      this.formData.accountNo = ''
      this.resetIfscStatus()
      // 如果选择usdt 默认 银行名称：USDT(TRC20)
      if (this.formData.accountTypeEnum === 2) {
        this.formData.bankName = 'USDT(TRC20)'
      }
    },

    // 重置IFSC状态
    resetIfscStatus () {
      this.bankNameFromIFSC = ''
      this.ifscQueryStatus = ''
    },

    // IFSC代码输入事件
    onIfscCodeInput () {
      // 输入时重置状态，避免显示过期的查询结果
      if (this.ifscQueryStatus !== '') {
        this.resetIfscStatus()
        // 如果银行名称是自动填充的，清空它
        if (this.ifscQueryStatus === 'success') {
          this.formData.bankName = ''
        }
      }
    },

    // IFSC代码失焦事件
    onIfscCodeBlur () {
      if (this.formData.ifscCode && this.formData.ifscCode.trim()) {
        const formattedCode = formatIFSCCode(this.formData.ifscCode.trim())
        this.formData.ifscCode = formattedCode
        this.queryBankNameByIFSC(formattedCode)
      } else {
        this.resetIfscStatus()
      }
    },

    // 根据IFSC代码查询银行名称
    queryBankNameByIFSC (ifscCode) {
      // 首先验证格式（支持4位或11位）
      if (!validateIFSCFormat(ifscCode)) {
        this.ifscQueryStatus = 'failed'
        this.bankNameFromIFSC = ''
        return
      }

      // 设置加载状态
      this.ifscQueryStatus = 'loading'

      // 模拟异步查询
      setTimeout(() => {
        const bankName = getBankNameByIFSC(ifscCode)

        if (bankName && bankName !== 'Unknown Bank') {
          // 查询成功
          this.ifscQueryStatus = 'success'
          this.bankNameFromIFSC = bankName
          this.formData.bankName = bankName
        } else {
          // 查询失败 - 格式正确但找不到银行
          this.ifscQueryStatus = 'failed'
          this.bankNameFromIFSC = ''
        }
      }, 300)
    },

    // 格式化金额显示（带千分位）
    formatAmount,
    formatNumber
  }
}
</script>

<style lang="less" scoped>
.available-amount-card {
  margin-bottom: 24px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;

  .amount-label {
    font-size: 16px;
    margin-right: 8px;
  }

  .amount-value {
    font-size: 24px;
    font-weight: bold;
    margin-right: 12px;
  }

  .ant-btn-link {
    color: rgba(255, 255, 255, 0.8);

    &:hover {
      color: white;
    }
  }
}

.ant-form-model-item {
  margin-bottom: 24px;
}

.ant-radio-group {
  .ant-radio-wrapper {
    margin-right: 16px;
  }
}

.ifsc-bank-info {
  margin-top: 8px;
  padding: 8px;
  border-radius: 4px;
  background-color: #f0f0f0;

  &.success {
    border: 1px solid #52c41a;
    background-color: #f6ffed;
  }

  &.error {
    border: 1px solid #ff4d4f;
    background-color: #fff1f0;
  }

  &.loading {
    border: 1px solid #1890ff;
    background-color: #e6f7ff;
  }
}

.bank-name-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
</style>
